import { useState } from 'react'
import type { SchemaComicShow } from 'api'

import {
  Wrapper,
  VideoName,
  BookDecoration,
  BookDecorationItem1,
  BookDecorationItem2,
  StyledAesImage,
  VideoTags,
  VideoInfo,
  VideoNameWhite,
  // VideoInfoOnTop,
  // VideoInfoOnTopBackground,
  // VideoNameWhite
} from './Styled'
import { useSelector } from 'react-redux'
import { selectStation } from 'redux/selector/app'
import { useNavigateTo } from 'hooks/useNavigateTo'

interface ComicBoxProps {
  comicInfo: SchemaComicShow
  width?: string
  columns?: number
  overflow?: any
  titleInSlide?: boolean
  noDecoration?: boolean
  noLazy?: boolean
  allowUnload?: boolean
  hideTags?: boolean
  fontSize?: string | number
  [key: string]: any
}

export default function ComicBox({
  comicInfo,
  width,
  columns = 2,
  overflow,
  titleInSlide = false,
  noDecoration = false,
  noLazy = false,
  allowUnload = false,
  hideTags = false,
  fontSize,
  ...props
}: ComicBoxProps) {
  const { navigateToViewComic } = useNavigateTo()
  const station = useSelector(selectStation)

  const { title, tag_names = [], cover_url } = comicInfo

  const [blobs, setBlobs] = useState<Blob[]>([])

  const onVideoBoxClick = async () => {
    let posterImg: string | undefined
    const imgBlob = blobs[0]
    if (imgBlob) {
      posterImg = await new Promise<string | undefined>((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(imgBlob)
        reader.onload = () => {
          resolve(typeof reader.result === 'string' ? reader.result : undefined)
        }
      })
    }
    navigateToViewComic({
      posterImg,
      comicInfo: {
        ...comicInfo,
      },
    })
  }

  return (
    <Wrapper {...props} onClick={onVideoBoxClick} width={width} columns={columns}>
      {!noDecoration && (
        <BookDecoration>
          <BookDecorationItem1 />
          <BookDecorationItem2 />
        </BookDecoration>
      )}
      <StyledAesImage
        source="comic"
        decryptKey={station.cover_key}
        aspectRatio={1 / 1.414}
        src={cover_url}
        onImageBlobsLoad={setBlobs}
        noLazy={noLazy}
        allowUnload={allowUnload}
      />

      <VideoInfo>
        {!titleInSlide && <VideoName>{title}</VideoName>}
        {titleInSlide && <VideoNameWhite fontSize={fontSize}>{title}</VideoNameWhite>}
        {/* limit visible tag to 2 tags */}
        {!hideTags && tag_names.length > 0 && <VideoTags>{tag_names.slice(0, 2).join(' ')}</VideoTags>}
      </VideoInfo>
    </Wrapper>
  )
}
